import { SHStack, SHTypography } from "@components/design-systems";
import { CheckSVG, CrossSVG } from "@components/svgs";
import { MAAnalysisDataDTO } from "@models/managed-accounts/entities/step/fee";
import { ManagedAccountFieldTypeValue } from "@models/managed-accounts/enums/fieldTypeValue";
import { AnalysisVariable } from "@models/platform-analysis/enums/variableName";
import { memo } from "react";

interface YesNoCellProps {
  analysisData?: MAAnalysisDataDTO;
  variableName?: AnalysisVariable;
  isModelInception?: boolean;
}

export const YesNoCell = memo(
  ({
    analysisData,
    variableName,
    isModelInception = variableName === AnalysisVariable.Model_inception,
  }: YesNoCellProps) => {
    const { value } = analysisData || {};

    const renderModelInception = () => {
      if (!isModelInception) return null;
      return RenderModelInceptionValueMap[
        value as ManagedAccountFieldTypeValue
      ];
    };

    const renderValue = () => {
      const specialValue = renderModelInception();
      if (specialValue) return specialValue;
      const renderValue = RenderValueMap[value as ManagedAccountFieldTypeValue];
      if (renderValue) return renderValue;
      return (
        <SHTypography variant="body3" colorVariant="third" lineHeight="120%">
          {analysisData?.value}
        </SHTypography>
      );
    };

    return <>{renderValue()}</>;
  },
);

const RenderModelInceptionValueMap: Partial<
  Record<ManagedAccountFieldTypeValue, JSX.Element>
> = {
  [ManagedAccountFieldTypeValue.True]: (
    <SHTypography variant="body3" colorVariant="third" lineHeight="120%">
      Yes
    </SHTypography>
  ),
  [ManagedAccountFieldTypeValue.False]: (
    <SHStack direction="row" spacing={1} justifyContent="center">
      <SHTypography variant="body3" colorVariant="third" lineHeight="120%">
        No
      </SHTypography>
      <CheckSVG />
    </SHStack>
  ),
};

const RenderValueMap: Partial<
  Record<ManagedAccountFieldTypeValue, JSX.Element>
> = {
  [ManagedAccountFieldTypeValue.True]: <CheckSVG />,
  [ManagedAccountFieldTypeValue.False]: <CrossSVG />,
  [ManagedAccountFieldTypeValue.Multiple]: (
    <SHTypography variant="body3" colorVariant="third" lineHeight="120%">
      Multiple
    </SHTypography>
  ),
};
